export default __webpack_public_path__ + "static/model_2-774007f84b29dbc8aad750d695ae72b6.webp";